// import React, { useEffect, useState } from 'react'
// import { NavLink, useLocation, useNavigate } from 'react-router-dom'
// import { useDispatch, useSelector } from 'react-redux'
// import { BookingFormHeader } from '../Common/BookingFormHeader'
// import { BookingFooter } from '../Common/BookingFooter'
// import { confirmBookingThunk } from '../../../Redux/Slices/BON-Frontend/confirmBookingSlice'
// import { fetchFrontTermsAndConditions } from '../../../Redux/Slices/BON-Frontend/frontTermsSlice'
// import { toast, ToastContainer } from "react-toastify";
// import Select from "react-select";
// import '../../../../BookingPage.css';
// export const BookingPage = () => {
//     const dispatch = useDispatch()
//     const navigate = useNavigate()
//     const [isTermsAccepted, setIsTermsAccepted] = useState(false);
//     const [termsError, setTermsError] = useState(false);
//     const { loading } = useSelector((state) => state.confirmBooking)
//     const { propertyDetails } = useSelector((state) => state.property);
//     const { terms, loading: termsLoading } = useSelector((state) => state.frontTerms);

//     const location = useLocation()
//     const bookingData = location.state || {}
//     const {
//         PropertyID,
//         pid: bookingPid,
//         preBookingToken,
//         checkInDate,
//         checkOutDate,
//         rooms = []
//     } = bookingData
//     const pid = bookingPid
//     // console.log(pid)

//     const totalRoomAmount = rooms.reduce(
//         (sum, room) => sum + Number(room.rate || 0),
//         0
//     )

//     const totalTax = rooms.reduce((sum, room) => {
//         const rate = Number(room.rate || 0)
//         const tax = rate < 7500
//             ? (rate * 5) / 100
//             : (rate * 18) / 100
//         return sum + tax
//     }, 0)

//     const grandTotal = totalRoomAmount + totalTax

//     const [guestForm, setGuestForm] = useState({
//         Title: '',
//         FirstName: '',
//         MiddleName: '',
//         LastName: '',
//         Address: '',
//         MobileNumber: '',
//         EmailAddress: '',
//         City: '',
//         State: '',
//         Country: '',
//     })

//     const [countries, setCountries] = useState([]);
//     const [states, setStates] = useState([]);
//     const [cities, setCities] = useState([]);
//     const [isTermsOpen, setIsTermsOpen] = useState(false);

//     useEffect(() => {
//         if (pid) {
//             dispatch(fetchFrontTermsAndConditions(pid));
//         }
//     }, [dispatch, pid]);

//     useEffect(() => {
//         if (!isTermsOpen) return;

//         const handleEscape = (event) => {
//             if (event.key === 'Escape') {
//                 setIsTermsOpen(false);
//             }
//         };

//         document.body.classList.add('bp-drawer-open');
//         window.addEventListener('keydown', handleEscape);

//         return () => {
//             document.body.classList.remove('bp-drawer-open');
//             window.removeEventListener('keydown', handleEscape);
//         };
//     }, [isTermsOpen]);

//     // Load Countries
//     useEffect(() => {
//         fetch("https://countriesnow.space/api/v0.1/countries/positions")
//             .then((res) => res.json())
//             .then((data) => {
//                 setCountries(data.data || []);
//             })
//             .catch((err) => console.error(err));
//     }, []);

//     // Load States when Country changes
//     useEffect(() => {
//         if (!guestForm.Country) {
//             setStates([]);
//             return;
//         }

//         fetch("https://countriesnow.space/api/v0.1/countries/states", {
//             method: "POST",
//             headers: {
//                 "Content-Type": "application/json",
//             },
//             body: JSON.stringify({
//                 country: guestForm.Country,
//             }),
//         })
//             .then((res) => res.json())
//             .then((data) => {
//                 setStates(data.data?.states || []);
//             })
//             .catch((err) => console.error(err));
//     }, [guestForm.Country]);

//     // Load Cities when State changes
//     useEffect(() => {
//         if (!guestForm.Country || !guestForm.State) {
//             setCities([]);
//             return;
//         }

//         fetch(
//             "https://countriesnow.space/api/v0.1/countries/state/cities",
//             {
//                 method: "POST",
//                 headers: {
//                     "Content-Type": "application/json",
//                 },
//                 body: JSON.stringify({
//                     country: guestForm.Country,
//                     state: guestForm.State,
//                 }),
//             }
//         )
//             .then((res) => res.json())
//             .then((data) => {
//                 setCities(data.data || []);
//             })
//             .catch((err) => console.error(err));
//     }, [guestForm.Country, guestForm.State]);

//     const handleInputChange = (e) => {
//         const { name, value } = e.target;

//         if (name === "Country") {
//             setGuestForm({
//                 ...guestForm,
//                 Country: value,
//                 State: "",
//                 City: "",
//             });
//         } else if (name === "State") {
//             setGuestForm({
//                 ...guestForm,
//                 State: value,
//                 City: "",
//             });
//         } else {
//             setGuestForm({
//                 ...guestForm,
//                 [name]: value,
//             });
//         }
//     };


//     const handleSelectChange = (selectedOption, field) => {
//         const value = selectedOption ? selectedOption.value : "";

//         if (field === "Country") {
//             setGuestForm({
//                 ...guestForm,
//                 Country: value,
//                 State: "",
//                 City: "",
//             });
//         } else if (field === "State") {
//             setGuestForm({
//                 ...guestForm,
//                 State: value,
//                 City: "",
//             });
//         } else {
//             setGuestForm({
//                 ...guestForm,
//                 [field]: value,
//             });
//         }
//     };

//     const handleConfirmBooking = async () => {

//         // ✅ Validation
//         if (!guestForm.Title) {
//             toast.error("Please select a Prefix.", { position: "top-right", autoClose: 2000 });
//             return;
//         }
//         if (!guestForm.FirstName.trim()) {
//             toast.error("Please Enter First Name.", { position: "top-right", autoClose: 2000 });
//             return;
//         }
//         if (!guestForm.LastName.trim()) {
//             toast.error("Please Enter Last Name.", { position: "top-right", autoClose: 2000 });
//             return;
//         }
//         if (!guestForm.Address.trim()) {
//             toast.error("Please Enter Address.", { position: "top-right", autoClose: 2000 });
//             return;
//         }
//         if (!guestForm.MobileNumber.trim()) {
//             toast.error("Please Enter Mobile Number.", { position: "top-right", autoClose: 2000 });
//             return;
//         }
//         if (!guestForm.EmailAddress.trim()) {
//             toast.error("Please Enter Email Address.", { position: "top-right", autoClose: 2000 });
//             return;
//         }
//         if (!guestForm.Country) {
//             toast.error("Please Select a country.", { position: "top-right", autoClose: 2000 });
//             return;
//         }
//         if (!guestForm.State) {
//             toast.error("Please select a state.", { position: "top-right", autoClose: 2000 });
//             return;
//         }
//         if (!guestForm.City) {
//             toast.error("Please select a city.", { position: "top-right", autoClose: 2000 });
//             return;
//         }

//         if (!isTermsAccepted) {
//             setTermsError(true);
//             return;
//         }

//         // Agar checked hai to error hata do
//         setTermsError(false);

//         const RoomDetails = rooms.map((room) => {
//             const rate = Number(room.rate || 0);
//             const tax = rate < 7500
//                 ? (rate * 5) / 100
//                 : (rate * 18) / 100;

//             return {
//                 RoomID: room.roomID || 0,
//                 // RatePlanID: room.ratePlanID || 0,
//                 RatePlanID: 'RROD',
//                 MealPlanID: room.mealPlanCode || '',
//                 TotalRoom: room.roomCount || 1,
//                 RoomRate: rate,
//                 ExtraBed: room.extraBed || 0,
//                 ExtraBedAmount: room.extraBedAmount || 0,
//                 Adults: room.adults || 1,
//                 Child: room.child || 0,
//                 Tax: tax,
//                 TaxRate: rate < 7500 ? 5 : 18,
//                 NetAmount: rate + tax,
//             };
//         });

//         const payload = {
//             PreBookingToken: preBookingToken || '',
//             TotalRoomRate: totalRoomAmount,
//             TotalExtraBedCharges: 0,
//             TotalPayment: grandTotal,
//             Tax: totalTax,
//             TotalAfterTax: grandTotal,
//             Discount: 0,
//             PaymentComment: 'Website',
//             CompanyName: '',
//             RegistrationNumber: '',
//             RegistrationCompanyName: '',
//             RegistrationCompanyAddress: '',
//             MarketSegment: 'R-WEBSITE',
//             BusinessSource : 'CRS',
//             BookingComment: 'Hotel Website',
//             Title: guestForm.Title,
//             FirstName: guestForm.FirstName,
//             MiddleName: guestForm.MiddleName,
//             LastName: guestForm.LastName,
//             EmailAddress: guestForm.EmailAddress,
//             Address: guestForm.Address,
//             MobileNumber: guestForm.MobileNumber,
//             Country: guestForm.Country,
//             State: guestForm.State,
//             City: guestForm.City,
//             GuaranteeCodes: 'CA',
//             PropertyID: pid,
//             RoomDetails,
//         };

//         // console.log("Booking Payload =>", payload);

//         // console.log("Booking Formdata Payload =>", payload);

//         try {
//             const response = await dispatch(confirmBookingThunk(payload)).unwrap();

//             toast.success("Your booking is submitted successfully!", {
//                 position: "top-right",
//                 autoClose: 1000,
//             });

//             setTimeout(() => {
//                 navigate("/BookingConfirmed", {
//                     state: {
//                         checkInDate,
//                         checkOutDate,
//                         propertyName: propertyDetails?.PropertyName,
//                         address: propertyDetails?.Address,
//                     }
//                 });
//             }, 1000);

//         } catch (error) {
//             toast.error("Booking failed. Please try again!", {
//                 position: "top-right",
//                 autoClose: 2000,
//             });
//         }
//     };

//     const formatDate = (dateString) => {
//         if (!dateString) return "-";

//         const date = new Date(dateString);

//         return date.toLocaleDateString("en-GB", {
//             day: "2-digit",
//             month: "short",
//             year: "numeric",
//         });
//     };

//     const getTermDescription = (item) => {
//         if (!item) return "";
//         if (typeof item === "string") return item;

//         return (
//             item.Description ||
//             item.TermsAndCondition ||
//             item.TermAndCond ||
//             item.Terms ||
//             item.Content ||
//             item.Text ||
//             ""
//         );
//     };

//     const normalizeTerms = (value) => {
//         if (Array.isArray(value)) return value;
//         if (Array.isArray(value?.data)) return value.data;
//         if (Array.isArray(value?.Data)) return value.Data;
//         if (Array.isArray(value?.terms)) return value.terms;
//         if (Array.isArray(value?.Terms)) return value.Terms;
//         return value ? [value] : [];
//     };

//     const termsList = normalizeTerms(terms)
//         .filter((item) => item?.IsActive !== false)
//         .sort((a, b) => Number(a?.SortOrder || 0) - Number(b?.SortOrder || 0));

//     const hasTerms = termsList.some((item) => getTermDescription(item));

//     return (
//         <>
//             <BookingFormHeader />
//             <main className="container-xl" style={{ marginTop: 80 }}>
//                 <div className="row g-4">
//                     {/* Left Column */}
//                     <div className="col-lg-8" data-purpose="guest-and-contact-info">
//                         {/* Deluxe Room Section */}
//                         <section
//                             className="card p-4 bp-custom-shadow"
//                             data-purpose="room-details-form"
//                         >
//                             {/* Guest 1 */}
//                             <div className="mb-4">
//                                 <label className="form-label">
//                                     Guest <span className="text-danger">*</span>
//                                 </label>

//                                 {/* Prefix, First Name & Last Name */}
//                                 <div className="row mb-3">
//                                     <div className="col-md-3">
//                                         <label className="form-label">Prefix</label>
//                                         <select
//                                             name="Title"
//                                             className="form-select form-control"
//                                             onChange={handleInputChange}
//                                             value={guestForm.Title}
//                                         >
//                                             <option value="">Select Prefix</option>
//                                             <option value="Mr">Mr.</option>
//                                             <option value="Mrs">Mrs.</option>
//                                             <option value="Ms">Ms.</option>
//                                             <option value="Dr">Dr.</option>
//                                         </select>
//                                     </div>

//                                     <div className="col-md-5">
//                                         <label className="form-label">First Name</label>
//                                         <input
//                                             type="text"
//                                             name="FirstName"
//                                             className="form-control"
//                                             placeholder="First Name"
//                                             value={guestForm.FirstName}
//                                             onChange={handleInputChange}
//                                         />
//                                     </div>

//                                     <div className="col-md-4">
//                                         <label className="form-label">Last Name</label>
//                                         <input
//                                             type="text"
//                                             name="LastName"
//                                             className="form-control"
//                                             placeholder="Last Name"
//                                             value={guestForm.LastName}
//                                             onChange={handleInputChange}
//                                         />
//                                     </div>
//                                 </div>

//                                 {/* Address */}
//                                 <div className="mb-3">
//                                     <label className="form-label">Address</label>
//                                     <textarea
//                                         name="Address"
//                                         className="form-control"
//                                         rows="2"
//                                         placeholder="Enter Address"
//                                         value={guestForm.Address}
//                                         onChange={handleInputChange}
//                                     ></textarea>
//                                 </div>

//                                 {/* Mobile, Email, City */}
//                                 <div className="row mb-3">
//                                     <div className="col-md-5">
//                                         <label className="form-label">Mobile Number</label>
//                                         <input
//                                             type="tel"
//                                             name="MobileNumber"
//                                             className="form-control"
//                                             placeholder="Mobile Number"
//                                             value={guestForm.MobileNumber}
//                                             onChange={handleInputChange}
//                                         />
//                                     </div>

//                                     <div className="col-md-7">
//                                         <label className="form-label">Email</label>
//                                         <input
//                                             type="email"
//                                             name="EmailAddress"
//                                             className="form-control"
//                                             placeholder="Email Address"
//                                             value={guestForm.EmailAddress}
//                                             onChange={handleInputChange}
//                                         />
//                                     </div>

//                                     <div className="col-md-4">
//                                         <label className="form-label">Country</label>

//                                         <Select
//                                             placeholder="Select Country"
//                                             options={countries.map((country) => ({
//                                                 value: country.name,
//                                                 label: country.name,
//                                             }))}
//                                             value={
//                                                 guestForm.Country
//                                                     ? { value: guestForm.Country, label: guestForm.Country }
//                                                     : null
//                                             }
//                                             onChange={(option) => handleSelectChange(option, "Country")}
//                                             isSearchable
//                                         />
//                                     </div>

//                                     <div className="col-md-4">
//                                         <label className="form-label">State</label>

//                                         <Select
//                                             placeholder="Select State"
//                                             options={states.map((state) => ({
//                                                 value: state.name,
//                                                 label: state.name,
//                                             }))}
//                                             value={
//                                                 guestForm.State
//                                                     ? { value: guestForm.State, label: guestForm.State }
//                                                     : null
//                                             }
//                                             onChange={(option) => handleSelectChange(option, "State")}
//                                             isDisabled={!guestForm.Country}
//                                             isSearchable
//                                         />
//                                     </div>

//                                     <div className="col-md-4">
//                                         <label className="form-label">City</label>

//                                         <Select
//                                             placeholder="Select City"
//                                             options={cities.map((city) => ({
//                                                 value: city,
//                                                 label: city,
//                                             }))}
//                                             value={
//                                                 guestForm.City
//                                                     ? { value: guestForm.City, label: guestForm.City }
//                                                     : null
//                                             }
//                                             onChange={(option) => handleSelectChange(option, "City")}
//                                             isDisabled={!guestForm.State}
//                                             isSearchable
//                                         />
//                                     </div>


//                                 </div>
//                             </div>
//                         </section>
//                     </div>

//                     {/* Right Sidebar */}
//                     <aside className="col-lg-4" data-purpose="booking-summary-and-payment">
//                         <div className="card bp-sidebar-card bp-custom-shadow">
//                             {/* Header */}
//                             <div className="card-header bg-white border-bottom border-light p-3 d-flex justify-content-between align-items-center">
//                                 <h2 className="h6 fw-bold mb-0">Booking Details</h2>
//                                 <NavLink to="/" className="btn bp-btn-black py-1 px-2 d-flex align-items-center">
//                                     <span className="me-1" style={{ fontSize: 8 }}>❮</span>
//                                     Book more
//                                 </NavLink>
//                             </div>

//                             <div className="card-body p-3">
//                                 {rooms.map((room, index) => (
//                                     <div key={index} className="mb-3 border-bottom pb-3">
//                                         {/* Room Title */}
//                                         <div className="d-flex justify-content-between align-items-start mb-0">
//                                             <h3 className="fw-bold small mb-0">
//                                                 {room.roomName}
//                                             </h3>
//                                             <button
//                                                 className="btn btn-link p-0 text-secondary"
//                                                 style={{ lineHeight: 1 }}
//                                             >
//                                                 <svg
//                                                     className="h-4 w-4"
//                                                     fill="none"
//                                                     stroke="currentColor"
//                                                     style={{ width: 16, height: 16 }}
//                                                     viewBox="0 0 24 24"
//                                                 >
//                                                     <path
//                                                         d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
//                                                         strokeLinecap="round"
//                                                         strokeLinejoin="round"
//                                                         strokeWidth={2}
//                                                     />
//                                                 </svg>
//                                             </button>
//                                         </div>

//                                         <p className="text-success bp-text-xxs fw-medium font-italic text-decoration-underline mb-3">
//                                             {room.mealPlanName}
//                                         </p>

//                                         {/* Dates and Occupancy */}
//                                         <div className="d-flex align-items-center justify-content-between bp-bg-gray-custom p-2 rounded mb-4">
//                                             <div className="d-flex gap-3">
//                                                 <div>
//                                                     <p className="text-secondary bp-text-xxs mb-0">Check In</p>
//                                                     <p className="fw-bold bp-text-xxs mb-0">
//                                                         {formatDate(checkInDate)}
//                                                     </p>
//                                                 </div>

//                                                 <div>
//                                                     <p className="text-secondary bp-text-xxs mb-0">Check Out</p>
//                                                     <p className="fw-bold bp-text-xxs mb-0">
//                                                         {formatDate(checkOutDate)}
//                                                     </p>
//                                                 </div>
//                                             </div>

//                                             <div className="text-end">
//                                                 <div className="d-flex align-items-center justify-content-end gap-2">
//                                                     <span className="fw-bold bp-text-xxs">{room.adults} Adult</span>
//                                                     {room.child > 0 && (
//                                                         <span className="fw-bold bp-text-xxs">{room.child} Child</span>
//                                                     )}
//                                                     <span className="fw-bold bp-text-xxs">{room.roomCount} Room</span>
//                                                 </div>
//                                                 <p className="fw-bold small mb-0">
//                                                     INR {Number(room.rate || 0).toLocaleString("en-IN")}
//                                                 </p>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 ))}

//                                 {/* Pricing Table */}
//                                 <div className="mb-4">
//                                     <div className="d-flex justify-content-between align-items-center bp-text-xs mb-1">
//                                         <span className="text-success cursor-pointer">
//                                             Taxes <span style={{ fontSize: 7 }}>▼</span>
//                                         </span>
//                                         <span className="fw-semibold">INR {totalTax.toLocaleString("en-IN")}</span>
//                                     </div>
//                                     <div className="d-flex justify-content-between align-items-end pt-1">
//                                         <span className="fw-bold small">Total</span>
//                                         <div className="text-end">
//                                             <span className="bp-price-breakdown">( Price breakdown )</span>
//                                             <span className="fw-bold small ms-1">INR {grandTotal.toLocaleString("en-IN")}</span>
//                                         </div>
//                                     </div>
//                                 </div>

//                                 {/* Sidebar Total */}
//                                 <div className="d-flex justify-content-between align-items-center mb-4 pt-2 border-top border-light">
//                                     <span className="fw-bold small">Total</span>
//                                     <span className="fw-bold small">INR {grandTotal.toLocaleString("en-IN")}</span>
//                                 </div>

//                                 {/* Terms and Submit */}
//                                 <div className="mb-4">
//                                     <div className="d-flex align-items-start mb-2">
//                                         <input
//                                             type="checkbox"
//                                             checked={isTermsAccepted}
//                                             onChange={(e) => {
//                                                 setIsTermsAccepted(e.target.checked);

//                                                 if (e.target.checked) {
//                                                     setTermsError(false);
//                                                 }
//                                             }}
//                                             className={`form-check-input mt-1 me-2 ${termsError ? "" : "border-secondary"
//                                                 }`}
//                                             style={{
//                                                 width: 14,
//                                                 height: 14,
//                                                 outline: termsError ? "2px solid rgba(70, 51, 156, 0.6)" : "none",
//                                                 boxShadow: termsError
//                                                     ? "0 0 5px rgba(70, 51, 156, 0.6)"
//                                                     : "none",
//                                             }}
//                                         />
//                                         <p className="bp-text-xxs mb-0" style={{ lineHeight: "1.3" }}>
//                                             By booking, you have agreed to our{' '}
//                                             <button
//                                                 type="button"
//                                                 className="bp-terms-link text-success fw-medium text-decoration-underline"
//                                                 onClick={() => setIsTermsOpen(true)}
//                                             >
//                                                 Terms and Conditions
//                                             </button>
//                                         </p>
//                                     </div>

//                                 </div>

//                                 <button
//                                     className="btn bp-btn-confirm"
//                                     onClick={handleConfirmBooking}
//                                     disabled={loading}
//                                 >
//                                     {loading ? 'Booking...' : 'Confirm Booking'}
//                                 </button>
//                             </div>
//                         </div>
//                     </aside>
//                 </div>
//             </main>

//             <BookingFooter />
//             <div
//                 className={`bp-terms-overlay ${isTermsOpen ? 'show' : ''}`}
//                 onClick={() => setIsTermsOpen(false)}
//                 aria-hidden={!isTermsOpen}
//             />
//             <aside
//                 className={`bp-terms-drawer ${isTermsOpen ? 'show' : ''}`}
//                 aria-hidden={!isTermsOpen}
//                 aria-labelledby="bp-terms-title"
//                 aria-modal={isTermsOpen}
//                 role="dialog"
//             >
//                 <div className="bp-terms-drawer-header">
//                     <h2 id="bp-terms-title">Terms and Conditions</h2>
//                     <button
//                         type="button"
//                         className="bp-terms-close"
//                         onClick={() => setIsTermsOpen(false)}
//                         aria-label="Close terms and conditions"
//                     >
//                         &times;
//                     </button>
//                 </div>

//                 <div className="bp-terms-drawer-body">
//                     {termsLoading ? (
//                         <p>Loading terms and conditions...</p>
//                     ) : hasTerms ? (
//                         termsList.map((item, index) => {
//                             const description = getTermDescription(item);

//                             if (!description) return null;

//                             return (
//                                 <p
//                                     key={item?.ID || index}
//                                     style={{ whiteSpace: "pre-line" }}
//                                 >
//                                     {description}
//                                 </p>
//                             );
//                         })
//                     ) : (
//                         <p>No terms and conditions available.</p>
//                     )}
//                 </div>
//             </aside>
//             <ToastContainer />
//         </>
//     )
// }





import React, { useEffect, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { BookingFormHeader } from "../Common/BookingFormHeader";
import { BookingFooter } from "../Common/BookingFooter";
import { confirmBookingThunk } from "../../../Redux/Slices/BON-Frontend/confirmBookingSlice";
import { fetchFrontTermsAndConditions } from "../../../Redux/Slices/BON-Frontend/frontTermsSlice";
import { toast, ToastContainer } from "react-toastify";
import Select from "react-select";
import "../../../../BookingPage.css";
import FullScreenLoader from "../Common/FullScreenLoader";

export const BookingPage = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const [isTermsAccepted, setIsTermsAccepted] = useState(false);
    const [termsError, setTermsError] = useState(false);
    const [isTermsOpen, setIsTermsOpen] = useState(false);

    const [countries, setCountries] = useState([]);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);

    const { loading } = useSelector((state) => state.confirmBooking);
    const { propertyDetails } = useSelector((state) => state.property);

    const {
        terms,
        loading: termsLoading,
    } = useSelector((state) => state.frontTerms);

    const bookingData = location.state || {};

    const {
        pid: bookingPid,
        preBookingToken,
        checkInDate,
        checkOutDate,
        rooms = [],
        Table3 = [],
    } = bookingData;

    const pid = bookingPid;
    const bookingConfiguration = Table3?.[0] || {};

    const [guestForm, setGuestForm] = useState({
        Title: "",
        FirstName: "",
        MiddleName: "",
        LastName: "",
        Address: "",
        MobileNumber: "",
        EmailAddress: "",
        City: "",
        State: "",
        Country: "",
    });

    /* =========================================================
       ROOM PRICE CALCULATION (per single room, not per group)
    ========================================================= */

    const getRoomPricing = (room) => {
        const rate = Number(room?.rate || 0);

        // ₹7,500 se kam par 5%, ₹7,500 ya jyada par 18%
        const taxRate = rate < 7500 ? 5 : 18;
        const taxAmount = (rate * taxRate) / 100;
        const netAmount = rate + taxAmount;

        return {
            rate,
            taxRate,
            taxAmount,
            netAmount,
        };
    };

    const totalRoomAmount = rooms.reduce((total, room) => {
        const roomCount = Number(room?.roomCount || 1);
        const { rate } = getRoomPricing(room);

        return total + rate * roomCount;
    }, 0);

    const totalTax = rooms.reduce((total, room) => {
        const roomCount = Number(room?.roomCount || 1);
        const { taxAmount } = getRoomPricing(room);

        return total + taxAmount * roomCount;
    }, 0);

    const totalExtraBedCharges = rooms.reduce((total, room) => {
        const roomCount = Number(room?.roomCount || 1);
        const extraBedAmount = Number(room?.extraBedAmount || 0);

        return total + extraBedAmount * roomCount;
    }, 0);

    const grandTotal =
        totalRoomAmount +
        totalTax +
        totalExtraBedCharges;

    /* =========================================================
       FETCH TERMS
    ========================================================= */

    useEffect(() => {
        if (pid) {
            dispatch(fetchFrontTermsAndConditions(pid));
        }
    }, [dispatch, pid]);

    /* =========================================================
       TERMS DRAWER
    ========================================================= */

    useEffect(() => {
        if (!isTermsOpen) return;

        const handleEscape = (event) => {
            if (event.key === "Escape") {
                setIsTermsOpen(false);
            }
        };

        document.body.classList.add("bp-drawer-open");
        window.addEventListener("keydown", handleEscape);

        return () => {
            document.body.classList.remove("bp-drawer-open");
            window.removeEventListener("keydown", handleEscape);
        };
    }, [isTermsOpen]);

    /* =========================================================
       LOAD COUNTRIES
    ========================================================= */

    useEffect(() => {
        fetch("https://countriesnow.space/api/v0.1/countries/positions")
            .then((response) => response.json())
            .then((data) => {
                setCountries(data.data || []);
            })
            .catch((error) => {
                console.error("Error loading countries:", error);
            });
    }, []);

    /* =========================================================
       LOAD STATES
    ========================================================= */

    useEffect(() => {
        if (!guestForm.Country) {
            setStates([]);
            setCities([]);
            return;
        }

        fetch("https://countriesnow.space/api/v0.1/countries/states", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                country: guestForm.Country,
            }),
        })
            .then((response) => response.json())
            .then((data) => {
                setStates(data.data?.states || []);
            })
            .catch((error) => {
                console.error("Error loading states:", error);
            });
    }, [guestForm.Country]);

    /* =========================================================
       LOAD CITIES
    ========================================================= */

    useEffect(() => {
        if (!guestForm.Country || !guestForm.State) {
            setCities([]);
            return;
        }

        fetch(
            "https://countriesnow.space/api/v0.1/countries/state/cities",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    country: guestForm.Country,
                    state: guestForm.State,
                }),
            },
        )
            .then((response) => response.json())
            .then((data) => {
                setCities(data.data || []);
            })
            .catch((error) => {
                console.error("Error loading cities:", error);
            });
    }, [guestForm.Country, guestForm.State]);

    /* =========================================================
       INPUT CHANGE
    ========================================================= */

    const handleInputChange = (event) => {
        const { name, value } = event.target;

        if (name === "Country") {
            setGuestForm((previous) => ({
                ...previous,
                Country: value,
                State: "",
                City: "",
            }));

            return;
        }

        if (name === "State") {
            setGuestForm((previous) => ({
                ...previous,
                State: value,
                City: "",
            }));

            return;
        }

        setGuestForm((previous) => ({
            ...previous,
            [name]: value,
        }));
    };

    const handleSelectChange = (selectedOption, field) => {
        const value = selectedOption?.value || "";

        if (field === "Country") {
            setGuestForm((previous) => ({
                ...previous,
                Country: value,
                State: "",
                City: "",
            }));

            return;
        }

        if (field === "State") {
            setGuestForm((previous) => ({
                ...previous,
                State: value,
                City: "",
            }));

            return;
        }

        setGuestForm((previous) => ({
            ...previous,
            [field]: value,
        }));
    };

    /* =========================================================
       FORMAT DATE
    ========================================================= */

    const formatDate = (dateString) => {
        if (!dateString) return "-";

        const date = new Date(dateString);

        return date.toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
        });
    };

    /* =========================================================
       FORMAT CURRENCY
    ========================================================= */

    const formatCurrency = (amount) => {
        return Number(amount || 0).toLocaleString("en-IN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    };

    /* =========================================================
       CONFIRM BOOKING
    ========================================================= */

    const handleConfirmBooking = async () => {
        if (!guestForm.Title) {
            toast.error("Please select a Prefix.", {
                position: "top-right",
                autoClose: 2000,
            });

            return;
        }

        if (!guestForm.FirstName.trim()) {
            toast.error("Please Enter First Name.", {
                position: "top-right",
                autoClose: 2000,
            });

            return;
        }

        if (!guestForm.LastName.trim()) {
            toast.error("Please Enter Last Name.", {
                position: "top-right",
                autoClose: 2000,
            });

            return;
        }

        if (!guestForm.Address.trim()) {
            toast.error("Please Enter Address.", {
                position: "top-right",
                autoClose: 2000,
            });

            return;
        }

        if (!guestForm.MobileNumber.trim()) {
            toast.error("Please Enter Mobile Number.", {
                position: "top-right",
                autoClose: 2000,
            });

            return;
        }

        if (!guestForm.EmailAddress.trim()) {
            toast.error("Please Enter Email Address.", {
                position: "top-right",
                autoClose: 2000,
            });

            return;
        }

        if (!guestForm.Country) {
            toast.error("Please Select a country.", {
                position: "top-right",
                autoClose: 2000,
            });

            return;
        }

        if (!guestForm.State) {
            toast.error("Please select a state.", {
                position: "top-right",
                autoClose: 2000,
            });

            return;
        }

        if (!guestForm.City) {
            toast.error("Please select a city.", {
                position: "top-right",
                autoClose: 2000,
            });

            return;
        }

        if (!isTermsAccepted) {
            setTermsError(true);
            return;
        }

        setTermsError(false);

        /* =====================================================
           ROOM DETAILS
           IMPORTANT FIX:
           Pehle rooms.map() se har room-GROUP (jisme roomCount
           2, 3, etc. ho sakta tha) ke liye sirf EK JSON object
           banta tha (TotalRoom: roomCount).

           Ab rooms.flatMap() use kar rahe hain, jisse har
           physical room ke liye ALAG-ALAG JSON object banega.
           Jaise UI me "Room 1", "Room 2" alag cards dikhte hain,
           waise hi payload me bhi 2 alag objects jayenge.
        ===================================================== */

        const RoomDetails = rooms.flatMap((room) => {
            const roomCount = Number(room?.roomCount || 1);

            const {
                rate,
                taxRate,
                taxAmount,
                netAmount,
            } = getRoomPricing(room);

            const extraBedAmount = Number(room?.extraBedAmount || 0);

            // roomCount ke hisaab se har room ka alag JSON object
            return Array.from({ length: roomCount }).map(() => ({
                RoomID: room.roomID || 0,
                RatePlanID: bookingConfiguration.RateCode || "",
                MealPlanID: room.mealPlanCode || "",
                TotalRoom: 1, // ab har object sirf ek single room represent karega
                RoomRate: rate,
                TotalRoomRate: rate,
                ExtraBed: Number(room.extraBed || 0),
                ExtraBedAmount: extraBedAmount,
                TotalExtraBedAmount: extraBedAmount,
                Adults: Number(room.adults || 1),
                Child: Number(room.child || 0),
                TaxRate: taxAmount,
                Tax: taxRate,
                TotalTax: taxAmount,
                NetAmount: netAmount,
                TotalNetAmount: netAmount + extraBedAmount,
            }));
        });

        const payload = {
            PreBookingToken: preBookingToken || "",

            TotalRoomRate: totalRoomAmount,
            TotalExtraBedCharges: totalExtraBedCharges,

            TotalPayment: grandTotal,
            Tax: totalTax,
            TotalAfterTax: grandTotal,

            Discount: 0,
            PaymentComment: "Website",

            CompanyName: "",
            RegistrationNumber: "",
            RegistrationCompanyName: "",
            RegistrationCompanyAddress: "",

            MarketSegment: bookingConfiguration.MarketSegment || "",
            BusinessSource: bookingConfiguration.BusinessSource || "",
            BookingComment: "Hotel Website",

            Title: guestForm.Title,
            FirstName: guestForm.FirstName,
            MiddleName: guestForm.MiddleName,
            LastName: guestForm.LastName,

            EmailAddress: guestForm.EmailAddress,
            Address: guestForm.Address,
            MobileNumber: guestForm.MobileNumber,

            Country: guestForm.Country,
            State: guestForm.State,
            City: guestForm.City,

            GuaranteeCodes: bookingConfiguration.GuaranteeCode || "CA",
            PropertyID: pid,

            RoomDetails,
        };

        console.log("Confirm Booking Payload", payload);

        try {
            await dispatch(
                confirmBookingThunk(payload),
            ).unwrap();

            toast.success(
                "Your booking is submitted successfully!",
                {
                    position: "top-right",
                    autoClose: 1000,
                },
            );

            setTimeout(() => {
                navigate("/BookingConfirmed", {
                    state: {
                        checkInDate,
                        checkOutDate,
                        propertyName:
                            propertyDetails?.PropertyName,
                        address: propertyDetails?.Address,
                    },
                });
            }, 1000);
        } catch (error) {
            console.error("Booking confirmation error:", error);

            toast.error(
                error?.message ||
                "Booking failed. Please try again!",
                {
                    position: "top-right",
                    autoClose: 2000,
                },
            );
        }
    };

    /* =========================================================
       TERMS DATA
    ========================================================= */

    const getTermDescription = (item) => {
        if (!item) return "";

        if (typeof item === "string") {
            return item;
        }

        return (
            item.Description ||
            item.TermsAndCondition ||
            item.TermAndCond ||
            item.Terms ||
            item.Content ||
            item.Text ||
            ""
        );
    };

    const normalizeTerms = (value) => {
        if (Array.isArray(value)) return value;
        if (Array.isArray(value?.data)) return value.data;
        if (Array.isArray(value?.Data)) return value.Data;
        if (Array.isArray(value?.terms)) return value.terms;
        if (Array.isArray(value?.Terms)) return value.Terms;

        return value ? [value] : [];
    };

    const termsList = normalizeTerms(terms)
        .filter((item) => item?.IsActive !== false)
        .sort(
            (first, second) =>
                Number(first?.SortOrder || 0) -
                Number(second?.SortOrder || 0),
        );

    const hasTerms = termsList.some((item) =>
        getTermDescription(item),
    );

    return (
        <>
            {loading && (<FullScreenLoader />)}

            <BookingFormHeader />

            <main
                className="container-xl"
                style={{ marginTop: 80 }}
            >
                <div className="row g-4">
                    {/* Guest Details */}

                    <div
                        className="col-lg-8"
                        data-purpose="guest-and-contact-info"
                    >
                        <section
                            className="card p-4 bp-custom-shadow"
                            data-purpose="room-details-form"
                        >
                            <div className="mb-4">
                                <label className="form-label">
                                    Guest{" "}
                                    <span className="text-danger">
                                        *
                                    </span>
                                </label>

                                <div className="row mb-3">
                                    <div className="col-md-3">
                                        <label className="form-label">
                                            Prefix
                                        </label>

                                        <select
                                            name="Title"
                                            className="form-select form-control"
                                            onChange={
                                                handleInputChange
                                            }
                                            value={guestForm.Title}
                                        >
                                            <option value="">
                                                Select Prefix
                                            </option>
                                            <option value="Mr">
                                                Mr.
                                            </option>
                                            <option value="Mrs">
                                                Mrs.
                                            </option>
                                            <option value="Ms">
                                                Ms.
                                            </option>
                                            <option value="Dr">
                                                Dr.
                                            </option>
                                        </select>
                                    </div>

                                    <div className="col-md-5">
                                        <label className="form-label">
                                            First Name
                                        </label>

                                        <input
                                            type="text"
                                            name="FirstName"
                                            className="form-control"
                                            placeholder="First Name"
                                            value={
                                                guestForm.FirstName
                                            }
                                            onChange={
                                                handleInputChange
                                            }
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <label className="form-label">
                                            Last Name
                                        </label>

                                        <input
                                            type="text"
                                            name="LastName"
                                            className="form-control"
                                            placeholder="Last Name"
                                            value={
                                                guestForm.LastName
                                            }
                                            onChange={
                                                handleInputChange
                                            }
                                        />
                                    </div>
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">
                                        Address
                                    </label>

                                    <textarea
                                        name="Address"
                                        className="form-control"
                                        rows="2"
                                        placeholder="Enter Address"
                                        value={guestForm.Address}
                                        onChange={handleInputChange}
                                    />
                                </div>

                                <div className="row mb-3">
                                    <div className="col-md-5">
                                        <label className="form-label">
                                            Mobile Number
                                        </label>

                                        <input
                                            type="tel"
                                            name="MobileNumber"
                                            className="form-control"
                                            placeholder="Mobile Number"
                                            value={
                                                guestForm.MobileNumber
                                            }
                                            onChange={
                                                handleInputChange
                                            }
                                        />
                                    </div>

                                    <div className="col-md-7">
                                        <label className="form-label">
                                            Email
                                        </label>

                                        <input
                                            type="email"
                                            name="EmailAddress"
                                            className="form-control"
                                            placeholder="Email Address"
                                            value={
                                                guestForm.EmailAddress
                                            }
                                            onChange={
                                                handleInputChange
                                            }
                                        />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-4">
                                        <label className="form-label">
                                            Country
                                        </label>

                                        <Select
                                            placeholder="Select Country"
                                            options={countries.map(
                                                (country) => ({
                                                    value:
                                                        country.name,
                                                    label:
                                                        country.name,
                                                }),
                                            )}
                                            value={
                                                guestForm.Country
                                                    ? {
                                                        value:
                                                            guestForm.Country,
                                                        label:
                                                            guestForm.Country,
                                                    }
                                                    : null
                                            }
                                            onChange={(option) =>
                                                handleSelectChange(
                                                    option,
                                                    "Country",
                                                )
                                            }
                                            isSearchable
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <label className="form-label">
                                            State
                                        </label>

                                        <Select
                                            placeholder="Select State"
                                            options={states.map(
                                                (state) => ({
                                                    value:
                                                        state.name,
                                                    label:
                                                        state.name,
                                                }),
                                            )}
                                            value={
                                                guestForm.State
                                                    ? {
                                                        value:
                                                            guestForm.State,
                                                        label:
                                                            guestForm.State,
                                                    }
                                                    : null
                                            }
                                            onChange={(option) =>
                                                handleSelectChange(
                                                    option,
                                                    "State",
                                                )
                                            }
                                            isDisabled={
                                                !guestForm.Country
                                            }
                                            isSearchable
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <label className="form-label">
                                            City
                                        </label>

                                        <Select
                                            placeholder="Select City"
                                            options={cities.map(
                                                (city) => ({
                                                    value: city,
                                                    label: city,
                                                }),
                                            )}
                                            value={
                                                guestForm.City
                                                    ? {
                                                        value:
                                                            guestForm.City,
                                                        label:
                                                            guestForm.City,
                                                    }
                                                    : null
                                            }
                                            onChange={(option) =>
                                                handleSelectChange(
                                                    option,
                                                    "City",
                                                )
                                            }
                                            isDisabled={
                                                !guestForm.State
                                            }
                                            isSearchable
                                        />
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>

                    {/* Booking Details Sidebar */}

                    <aside
                        className="col-lg-4"
                        data-purpose="booking-summary-and-payment"
                    >
                        <div className="card bp-sidebar-card bp-custom-shadow">
                            <div className="card-header bg-white border-bottom border-light p-3 d-flex justify-content-between align-items-center">
                                <h2 className="h6 fw-bold mb-0">
                                    Booking Details
                                </h2>

                                <NavLink
                                    to="/"
                                    className="btn bp-btn-black py-1 px-2 d-flex align-items-center"
                                >
                                    <span
                                        className="me-1"
                                        style={{ fontSize: 8 }}
                                    >
                                        ❮
                                    </span>
                                    Book more
                                </NavLink>
                            </div>

                            <div className="card-body p-3">
                                {/* Check-in / Check-out ek baar */}

                                <div className="bp-bg-gray-custom rounded p-2 mb-3">
                                    <div className="d-flex justify-content-between">
                                        <div>
                                            <p className="text-secondary bp-text-xxs mb-1">
                                                Check In
                                            </p>

                                            <p className="fw-bold bp-text-xs mb-0">
                                                {formatDate(
                                                    checkInDate,
                                                )}
                                            </p>
                                        </div>

                                        <div className="text-end">
                                            <p className="text-secondary bp-text-xxs mb-1">
                                                Check Out
                                            </p>

                                            <p className="fw-bold bp-text-xs mb-0">
                                                {formatDate(
                                                    checkOutDate,
                                                )}
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                {/* Room Details */}

                                {rooms.map(
                                    (room, groupIndex) => {
                                        const roomCount = Number(
                                            room?.roomCount || 1,
                                        );

                                        const {
                                            rate,
                                            taxRate,
                                            taxAmount,
                                            netAmount,
                                        } =
                                            getRoomPricing(room);

                                        return (
                                            <div
                                                key={groupIndex}
                                                className="mb-3 border-bottom pb-3"
                                            >
                                                <div className="d-flex justify-content-between align-items-start">
                                                    <div>
                                                        <h3 className="fw-bold small mb-0">
                                                            {room.roomName ||
                                                                "Room"}
                                                        </h3>

                                                        <p className="text-success bp-text-xxs fw-medium font-italic text-decoration-underline mb-3">
                                                            {room.mealPlanName ||
                                                                ""}
                                                        </p>
                                                    </div>

                                                    <button
                                                        type="button"
                                                        className="btn btn-link p-0 text-secondary"
                                                        style={{
                                                            lineHeight: 1,
                                                        }}
                                                    >
                                                        <svg
                                                            fill="none"
                                                            stroke="currentColor"
                                                            style={{
                                                                width: 16,
                                                                height: 16,
                                                            }}
                                                            viewBox="0 0 24 24"
                                                        >
                                                            <path
                                                                d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                                strokeWidth={
                                                                    2
                                                                }
                                                            />
                                                        </svg>
                                                    </button>
                                                </div>

                                                {[
                                                    ...Array(
                                                        roomCount,
                                                    ),
                                                ].map(
                                                    (
                                                        _,
                                                        roomIndex,
                                                    ) => (
                                                        <div
                                                            key={
                                                                roomIndex
                                                            }
                                                            className="bp-bg-gray-custom p-2 rounded mb-2"
                                                        >
                                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                                                <span className="fw-bold bp-text-xs text-secondary">
                                                                    Room{" "}
                                                                    {roomIndex +
                                                                        1}
                                                                </span>

                                                                <div className="d-flex align-items-center gap-2">
                                                                    <span className="fw-bold bp-text-xxs">
                                                                        {Number(
                                                                            room.adults ||
                                                                            1,
                                                                        )}{" "}
                                                                        Adult
                                                                    </span>

                                                                    {Number(
                                                                        room.child ||
                                                                        0,
                                                                    ) >
                                                                        0 && (
                                                                            <span className="fw-bold bp-text-xxs">
                                                                                {
                                                                                    room.child
                                                                                }{" "}
                                                                                Child
                                                                            </span>
                                                                        )}
                                                                </div>
                                                            </div>

                                                            {/* Room Rate */}

                                                            <div className="d-flex justify-content-between align-items-center bp-text-xxs mb-1">
                                                                <span className="text-secondary">
                                                                    Room
                                                                    Rate
                                                                </span>

                                                                <span className="fw-semibold">
                                                                    INR{" "}
                                                                    {formatCurrency(
                                                                        rate,
                                                                    )}
                                                                </span>
                                                            </div>

                                                            {/* Tax Rate */}

                                                            <div className="d-flex justify-content-between align-items-center bp-text-xxs mb-1">
                                                                <span className="text-secondary">
                                                                    Tax
                                                                </span>

                                                                <span className="fw-semibold">
                                                                    {
                                                                        taxRate
                                                                    }
                                                                    %
                                                                </span>
                                                            </div>

                                                            {/* Tax Amount */}

                                                            <div className="d-flex justify-content-between align-items-center bp-text-xxs mb-1">
                                                                <span className="text-secondary">
                                                                    Tax
                                                                    Amount
                                                                </span>

                                                                <span className="fw-semibold">
                                                                    INR{" "}
                                                                    {formatCurrency(
                                                                        taxAmount,
                                                                    )}
                                                                </span>
                                                            </div>

                                                            {/* Net Amount */}

                                                            <div className="d-flex justify-content-between align-items-center border-top pt-2 mt-2">
                                                                <span className="fw-bold bp-text-xs">
                                                                    Net
                                                                    Amount
                                                                </span>

                                                                <span className="fw-bold small">
                                                                    INR{" "}
                                                                    {formatCurrency(
                                                                        netAmount,
                                                                    )}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    ),
                                                )}
                                            </div>
                                        );
                                    },
                                )}

                                {/* Price Summary */}

                                <div className="mb-4">
                                    <div className="d-flex justify-content-between align-items-center bp-text-xs mb-2">
                                        <span className="text-secondary">
                                            Total Room Rate
                                        </span>

                                        <span className="fw-semibold">
                                            INR{" "}
                                            {formatCurrency(
                                                totalRoomAmount,
                                            )}
                                        </span>
                                    </div>

                                    {totalExtraBedCharges > 0 && (
                                        <div className="d-flex justify-content-between align-items-center bp-text-xs mb-2">
                                            <span className="text-secondary">
                                                Extra Bed Charges
                                            </span>

                                            <span className="fw-semibold">
                                                INR{" "}
                                                {formatCurrency(
                                                    totalExtraBedCharges,
                                                )}
                                            </span>
                                        </div>
                                    )}

                                    <div className="d-flex justify-content-between align-items-center bp-text-xs mb-2">
                                        <span className="text-success">
                                            Total Tax
                                        </span>

                                        <span className="fw-semibold">
                                            INR{" "}
                                            {formatCurrency(
                                                totalTax,
                                            )}
                                        </span>
                                    </div>

                                    <div className="d-flex justify-content-between align-items-center border-top pt-2">
                                        <span className="fw-bold small">
                                            Net Total
                                        </span>

                                        <span className="fw-bold small">
                                            INR{" "}
                                            {formatCurrency(
                                                grandTotal,
                                            )}
                                        </span>
                                    </div>
                                </div>

                                {/* Final Total */}

                                <div className="d-flex justify-content-between align-items-center mb-4 pt-2 border-top border-light">
                                    <span className="fw-bold small">
                                        Total Payable
                                    </span>

                                    <span className="fw-bold small">
                                        INR{" "}
                                        {formatCurrency(
                                            grandTotal,
                                        )}
                                    </span>
                                </div>

                                {/* Terms */}

                                <div className="mb-4">
                                    <div className="d-flex align-items-start mb-2">
                                        <input
                                            type="checkbox"
                                            checked={
                                                isTermsAccepted
                                            }
                                            onChange={(event) => {
                                                setIsTermsAccepted(
                                                    event.target
                                                        .checked,
                                                );

                                                if (
                                                    event.target
                                                        .checked
                                                ) {
                                                    setTermsError(
                                                        false,
                                                    );
                                                }
                                            }}
                                            className={`form-check-input mt-1 me-2 ${termsError
                                                ? ""
                                                : "border-secondary"
                                                }`}
                                            style={{
                                                width: 14,
                                                height: 14,
                                                outline:
                                                    termsError
                                                        ? "2px solid rgba(70, 51, 156, 0.6)"
                                                        : "none",
                                                boxShadow:
                                                    termsError
                                                        ? "0 0 5px rgba(70, 51, 156, 0.6)"
                                                        : "none",
                                            }}
                                        />

                                        <p
                                            className="bp-text-xxs mb-0"
                                            style={{
                                                lineHeight: "1.3",
                                            }}
                                        >
                                            By booking, you have
                                            agreed to our{" "}
                                            <button
                                                type="button"
                                                className="bp-terms-link text-success fw-medium text-decoration-underline"
                                                onClick={() =>
                                                    setIsTermsOpen(
                                                        true,
                                                    )
                                                }
                                            >
                                                Terms and
                                                Conditions
                                            </button>
                                        </p>
                                    </div>

                                    {termsError && (
                                        <small className="text-danger">
                                            Please accept the Terms
                                            and Conditions.
                                        </small>
                                    )}
                                </div>

                                <button
                                    type="button"
                                    className="btn bp-btn-confirm"
                                    onClick={handleConfirmBooking}
                                >
                                    Confirm Booking
                                </button>
                            </div>
                        </div>
                    </aside>
                </div>
            </main>

            <BookingFooter />

            {/* Terms Overlay */}

            <div
                className={`bp-terms-overlay ${isTermsOpen ? "show" : ""
                    }`}
                onClick={() => setIsTermsOpen(false)}
                aria-hidden={!isTermsOpen}
            />

            {/* Terms Drawer */}

            <aside
                className={`bp-terms-drawer ${isTermsOpen ? "show" : ""
                    }`}
                aria-hidden={!isTermsOpen}
                aria-labelledby="bp-terms-title"
                aria-modal={isTermsOpen}
                role="dialog"
            >
                <div className="bp-terms-drawer-header">
                    <h2 id="bp-terms-title">
                        Terms and Conditions
                    </h2>

                    <button
                        type="button"
                        className="bp-terms-close"
                        onClick={() => setIsTermsOpen(false)}
                        aria-label="Close terms and conditions"
                    >
                        &times;
                    </button>
                </div>

                <div className="bp-terms-drawer-body">
                    {termsLoading ? (
                        <p>
                            Loading terms and conditions...
                        </p>
                    ) : hasTerms ? (
                        termsList.map((item, index) => {
                            const description =
                                getTermDescription(item);

                            if (!description) {
                                return null;
                            }

                            return (
                                <p
                                    key={
                                        item?.ID || index
                                    }
                                    style={{
                                        whiteSpace:
                                            "pre-line",
                                    }}
                                >
                                    {description}
                                </p>
                            );
                        })
                    ) : (
                        <p>
                            No terms and conditions available.
                        </p>
                    )}
                </div>
            </aside>

            <ToastContainer />
        </>
    );
};
